// extracted by mini-css-extract-plugin
module.exports = {"memberCard":"MembersCard_memberCard__133nh","progressBarContainer":"MembersCard_progressBarContainer__1bG6c","cardBody":"MembersCard_cardBody__j2gvK"};